
/*========================================================================
 * $Id$
 *
 * Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
 *
 * Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
 * Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
 * Urheber festgelegten Stelle in der Funktion des Computerprogramms
 * angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
 * Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
 * Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
 * =========================================================================*/

Mindbreeze.define('model/attribute_proxy',["underscore", "backbone", "utils/events"], function(_, Backbone, Events) {

  function AttributeProxyModel(model, attributeDefinitions) {
    this.model = model;
    if (this.model.output)
      this.output = this.model.output;
    if (this.model.input)
      this.input = this.model.input;
    this.attribtueDefinitions = attributeDefinitions;
    var that = this;
    this.listenTo(this.model, "all", function (eventName) {
      that.trigger.apply(that, arguments);
    });
  }

  _.extend(AttributeProxyModel.prototype, Backbone.Events, {

    get: function(attr) {
      if (this.attribtueDefinitions && this.attribtueDefinitions[attr] && this.attribtueDefinitions[attr].get) {
        var args = [this.model].concat(_.toArray(arguments));
        return this.attribtueDefinitions[attr].get.apply(this.model, args);
      }
      return this.model.get.apply(this.model, arguments);
    },

    set: function(key, val, options) {
      // TODO: also implement if key is actually a structured object ...
      if (this.attribtueDefinitions && this.attribtueDefinitions[key] && this.attribtueDefinitions[key].set) {
        var args = [this.model].concat(_.toArray(arguments));
        return this.attribtueDefinitions[key].set.apply(this.model, args);
      }
          
      return this.model.set.apply(this.model,arguments);
    },

    reset: function() {
      return this.model.reset.apply(this.model,arguments);
    },
    
    destroy: function() {
      try {
        this.model.destroy.apply(this.model, arguments);
      } catch (e) {}
      this.stopListening(this.model);
    }
  });

  return AttributeProxyModel;
  
})
;